import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import './ExpensesShell.css';

/**
 * Shared layout for Boss / Employee / Office expense list routes.
 */
export function ExpenseListShell({ title, lede, onAddExpense, children }) {
  const { t } = useLanguage();

  return (
    <div className="expenses-shell expenses-page page-bleed">
      <header className="expenses-header">
        <h1 className="expenses-title">{title}</h1>
        {lede ? <p className="expenses-lede">{lede}</p> : null}
      </header>
      <div className="expenses-toolbar">
        {typeof onAddExpense === 'function' ? (
          <button type="button" className="expenses-btn expenses-btn--primary" onClick={onAddExpense}>
            {t('exp.list.addExpense')}
          </button>
        ) : null}
      </div>
      <div className="expenses-card expenses-card--fill">{children}</div>
    </div>
  );
}
